var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "base-gauge",
      style: { width: _vm.width + "px", height: _vm.height + "px" }
    },
    [
      _c(
        "svg",
        {
          staticClass: "gauge-svg",
          attrs: { width: _vm.width, height: _vm.height, viewBox: "0 0 150 95" }
        },
        [
          _c("g", { attrs: { transform: "translate(75, 75)" } }, [
            _c("path", {
              attrs: {
                d: "M -45 -52 A 69 69 0 0 0 -69 0",
                fill: "none",
                stroke: _vm.segmentsColor[0],
                "stroke-width": _vm.strokeWidth,
                "stroke-linecap": "round"
              }
            }),
            _c("path", {
              attrs: {
                d: "M 30 -62 A 69 69 0 0 0 -30 -62",
                fill: "none",
                stroke: _vm.segmentsColor[1],
                "stroke-width": _vm.strokeWidth,
                "stroke-linecap": "round"
              }
            }),
            _c("path", {
              attrs: {
                d: "M 69 0 A 69 69 0 0 0 45 -52",
                fill: "none",
                stroke: _vm.segmentsColor[2],
                "stroke-width": _vm.strokeWidth,
                "stroke-linecap": "round"
              }
            }),
            _c(
              "g",
              { attrs: { transform: "rotate(" + _vm.pointerAngle + ")" } },
              [
                _c("line", {
                  attrs: {
                    x1: "0",
                    y1: "0",
                    x2: "60",
                    y2: "0",
                    stroke: _vm.pointerColor,
                    "stroke-width": "4",
                    "stroke-linecap": "round"
                  }
                }),
                _c("circle", {
                  attrs: { cx: "0", cy: "0", r: "6", fill: _vm.pointerColor }
                })
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }